import React, { useEffect, useState, useContext } from 'react';
import { AddItem, GetById, UpdateItem } from "../../../utils/functions";
import { useTranslation } from 'react-i18next';
import TextField from '../../../components/input/fields/text-field';
import { toast } from "react-toastify";
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { DataContext } from "../../../App";
import { Eye, EyeOff } from 'react-feather';
import { NavLink } from 'react-router-dom';

const Manage = (item) => {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const context = useContext(DataContext);
  const Uid = item.item !== "" ? item.item : null;
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  const [formValues, setformValues] = useState({
    displayName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues({ ...formValues, [name]: value });
  };

  const checkValues = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_-])[A-Za-z\d!@#$%^&*()_-]{8,}$/;
  
    if (!formValues) {
      toast.error(t("ToastErrorInvalidData"));
      return false;
    }

    if (!formValues.displayName) {
      toast.error(t("ToastErrorNameRequired"));
      return false;
    }
  
    if (!formValues.email){
      toast.error(t("ToastErrorEmailRequired"));
      return false;
    } 
    
    if(!emailRegex.test(formValues.email)) {
      toast.error(t("ToastErrorIncorrectEmail"));
      return false;
    }
  
    if (!Uid && !formValues.password){
      toast.error(t("ToastErrorPasswordRequired"));
      return false;
    } 
    
    if(!Uid && !formValues.confirmPassword) {
      toast.error(t("ToastErrorConfirmPasswordRequired"));
      return false;
    }
  
    if (!Uid && (
      formValues.password !== formValues.confirmPassword ||
      !passwordRegex.test(formValues.password))
    ) {
      toast.error(t("ToastErrorPasswordsMismatch"));
      return false;
    }
  
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsBtnDisable(true);

    if (checkValues()) {
      let resp = null;

      if (Uid) {
        resp = await UpdateItem('User', formValues);
      } else {
        resp = await AddItem('User', formValues);
      }
      if (resp) {
        await context.updateData("users");
        navigator("/admin/users");
      }
    }

    setIsBtnDisable(false);
  };

  useEffect(() => {
    const initialFetch = async () => {
      if (Uid) {
        const data = await GetById("User", item.item);

        if (data) {
          setformValues(data);
        }
      }
    };
    initialFetch();
  }, [Uid, item.item]);
  

  return (
    <div className="container-admin mt-5">
      <div className="row">
      <NavLink className="come-back-admin" to={"/admin/users"}>
          <FontAwesomeIcon icon={faAngleLeft}/>
          {t("Back")}
        </NavLink>
        <div className="row mt-5 pt-5 px-5">
          <div className="flex-wrap col-lg-6 my-3">
            <div className="d-flex flex-column">
              <TextField
                id={"displayName"}
                name={"displayName"}
                label={t("FullName")}
                type={"text"}
                inputClassName={"grey-input w-100"}
                placeholder={t("Insert")}
                onChange={handleChange}
                value={formValues.displayName}
                required
              />
            </div>
          </div>
          <div className="flex-wrap col-lg-6 my-3 ps-lg-4">
            <div className="d-flex flex-column">
              <TextField
                id={"email"}
                name={"email"}
                label={t("Email")}
                type={"text"}
                inputClassName={"grey-input w-100"}
                placeholder={t("Insert")}
                onChange={handleChange}
                value={formValues.email}
                required
              />
            </div>
          </div>
          {!Uid &&

            <div className="flex-wrap col-lg-6 my-3">
              <div className="d-flex flex-column position-relative w-100">
                <TextField
                  id={"password"}
                  name={"password"}
                  label={t("Password")}
                  type={isPasswordVisible ? "text" : "password"}
                  inputClassName={"grey-input w-100"}
                  placeholder={t("Insert")}
                  onChange={handleChange}
                  value={formValues.password}
                  required
                />
                <button
                  className="position-absolute end-0 pe-3 pt-2 bg-transparent border-none mt-2 top-50 translate-middle-y"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {!isPasswordVisible ? <EyeOff className="text-base text-black pt-1"/> : <Eye className="text-base text-black pt-1"/>}
                </button>
              </div>
            </div>}
          {!Uid &&
            <div className="flex-wrap col-lg-6 my-3 ps-lg-4">
              <div className="d-flex flex-column position-relative w-100">
                <TextField
                  id={"confirmPassword"}
                  name={"confirmPassword"}
                  label={t("ConfirmPassword")}
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  inputClassName={"grey-input w-100"}
                  placeholder={t("Insert")}
                  onChange={handleChange}
                  value={formValues.confirmPassword}
                  required
                />
                <button
                  className="position-absolute end-0 pe-3 pt-2 bg-transparent border-none mt-2 top-50 translate-middle-y"
                  onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                >
                  {!isConfirmPasswordVisible ? <EyeOff className="text-base text-black pt-1"/> : <Eye className="text-base text-black pt-1"/>}
                </button>
              </div>
            </div>
          }
          <div className="col-12 mt-3 d-flex justify-content-end">
            <button onClick={handleSubmit} className="admin-button border-none text-uppercase" disabled={isBtnDisable}>{Uid ? t("Update") : t("Create")}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manage;
